import {Generics, verticalPage} from "./generics.ts";
import {create} from "../../fjsc/src/f2.ts";

export class About {
    static page() {
        return Generics.pageFrame(
            true,
            verticalPage(
                Generics.heading(1, "About", ["bold"]),
                Generics.paragraph("Sayo ist eine sehr süße Maus und macht sehr leckere Bagels. Liebt alle Sayo :>"),
                create("hr"),
                create("div")
                    .classes("flex", "center-items", "color-dim")
                    .children(
                        Generics.paragraph("Made in Berlin, with ♥️"),
                    ).build(),
            )
        );
    }
}